import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tab, Tabs } from "@mui/material";
import ManagerStatementDocument from "./ManagerStatementDocument";
import ManagerInvoiceDocument from "./ManagerInvoiceDocument";
import DocumentsKpiSummary from "./DocumentsKpiSummary";

interface DocumentsTabProps {
  statementId: string;
  isInvoiceLocked: boolean;
}

const DocumentsTab: React.FC<DocumentsTabProps> = ({ statementId, isInvoiceLocked }) => {
  const { t } = useTranslation();
  const [subTab, setSubTab] = useState<"managerStatement" | "managerInvoice">("managerStatement");

  const handleSubTabChange = (_: any, value: "managerStatement" | "managerInvoice") => {
    setSubTab(value);
  };

  return (
    <div>
      <div className="px-6 pt-6">
        <DocumentsKpiSummary statementId={statementId} />
      </div>

      <div className="px-6 pt-2">
        <Tabs value={subTab} onChange={handleSubTabChange} textColor="primary">
          <Tab value="managerStatement" label={t("reconciliation.managerStatement.detail.pageTexts.documentsTab.subTabs.managerStatement")} />
          <Tab value="managerInvoice" label={t("reconciliation.managerStatement.detail.pageTexts.documentsTab.subTabs.managerInvoice")} />
        </Tabs>
      </div>

      <hr className="m-0" />

      {subTab === "managerStatement" ? (
        <ManagerStatementDocument statementId={statementId} />
      ) : (
        <ManagerInvoiceDocument statementId={statementId} isInvoiceLocked={isInvoiceLocked} />
      )}
    </div>
  );
};

export default DocumentsTab;
